enum SortOrder {
  DESC = 'DESC',
  ASC = 'ASC',
}
export default SortOrder;
